export default function SsdiConfirmations() {
  return (
    <div className="page">
      <h2>Confirmations</h2>
      <p>Repo agents will send found car details and live photos here for SSDI review.</p>
    </div>
  );
}